export function createGrupoEmpleado() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true
  };
}
